import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmAuthCaptchaNotProvidedError } from '@/core/error/transport/auth/TmAuthCaptchaNotProvidedError'

export const authCaptchaNotProvidedErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.login,
  methods: ['post'],
  klass: TmAuthCaptchaNotProvidedError,
}
